import { FC, MutableRefObject } from 'react'
import { getStyledNavBar } from '../../styled-components/NavBar.styled'
import { useWindowSize } from 'react-use';
import { MD_SCREEN } from '../../util/screen-size'
import { MobileIconHolder } from './MobileIconHolder.component'
import { TopNavBar } from './TopNavBar.component';

export interface refTypes{
    home: MutableRefObject<any>,
    feature: MutableRefObject<any>,
    about: MutableRefObject<any>,
    contact: MutableRefObject<any>,

}

export interface NavBarProps {
    refList: refTypes,
    action: (itemRef: MutableRefObject<any>) => void
}

export const NavBar: FC<NavBarProps> = ({action, refList}) => {

    const StyledNavBar = getStyledNavBar()
    const {width} = useWindowSize();
    const size = width > MD_SCREEN

    return (
        <StyledNavBar>
            {size
                ? <TopNavBar refList={refList} action={action} />
                : <MobileIconHolder refList={refList} action={action} />
            }
        </StyledNavBar>
    )
}